import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCt = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path
      fillRule="evenodd"
      d="m1200 689.92-25.789 9.332 12.895 59.211-22.621 10.031h-55.211l-37.891 18.422-48.191-18.422-9.14 18.422-52.29-18.422-16.43 37.43-113.41 17.988-15.996-17.988-52.656 17.988-24.207 9.945-28.594-13.047-48.332-5.64-19.445 18.688h-123.01l-14.145-27.934-63.19 61.203-54.845 18.203-35.844 41.156h-65.785l-83.465 56.809-65.309 22.762-86.988 34.367L.006 956.283l153.18-91.11-43.254-78.257 43.254-627.34 411.91 14.59v28.852l31.801-3.102 10.605-25.75 592.51 14.363z"
    />
  </svg>
);
export default SvgCt;
